import { useLocation } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import StarFullIcon from '@material-ui/icons/Star';
import StarEmptyIcon from '@material-ui/icons/StarBorder';

import useStateDataListForKey from 'modules/queries/account/user/stateData/useListForKey';
import { useAddFavorite } from 'modules/queries/account/user/stateData/useAdd';
import { useRemoveFavorite } from 'modules/queries/account/user/stateData/useRemove';

interface FavoritesToggleProps {
	displayName: string;
}

const FavoritesToggle = ({ displayName }: FavoritesToggleProps) => {
	const { data, isLoading } = useStateDataListForKey(
		{ key: 'favorites' },
		{ enabled: true },
	);
	const { pathname } = useLocation();
	const { mutate: removeFavorite, isLoading: removePending } =
		useRemoveFavorite();
	const { mutate: addFavorite, isLoading: addPending } = useAddFavorite();

	const favoritesList = Array.isArray(data?.data) ? data.data : [];
	const favoriteItem = favoritesList.find((f) => f.path === pathname);
	const isFavorite = Boolean(favoriteItem);

	const onToggle = () => {
		if (isLoading || addPending || removePending) return;
		if (isFavorite && favoriteItem) {
			removeFavorite({ uuid: favoriteItem.uuid });
		} else {
			addFavorite({ path: pathname, displayName });
		}
	};

	return (
		<IconButton
			color={isFavorite || isLoading ? 'secondary' : 'default'}
			aria-label="Favorites"
			onClick={onToggle}
			data-testid="FavoritesToggle__Button"
			disabled={isLoading || addPending || removePending}
		>
			{isFavorite || isLoading ? (
				<StarFullIcon fontSize="large" />
			) : (
				<StarEmptyIcon fontSize="large" />
			)}
		</IconButton>
	);
};

export default FavoritesToggle;
